import { CONTENT_GET } from '@annunciate/query/dist/queries/content';
import { useQuery } from './base';
export const useContentQuery = (id) => {
    return useQuery(['content'], CONTENT_GET, { id });
};
//# sourceMappingURL=useContentQuery.js.map